import { useState } from 'react';
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Checkbox,
} from 'antd';

import StrikeTeamDetailsModel from '../../models/StrikeTeamDetailsModel';
import {
  FormItemLayout,
} from '../../utils/Constants';

import {
  tailFormItemLayout, checkboxesLayout, headerLayout,
} from './EditTeamForm';
import { EditFieldSettingsView } from './EditFieldSettingsView';


export const TeamEditPaymentDetailsFeesFormItem = ({ team, disabled, form }) => {
  // Handle change to "Ask customer to accept fees" checkbox
  const handleShouldAddOnFeesChange = (e) => {
    const checked = e.target.checked;
    // If "Ask customer to accept fees" is ON, then "Allow customer to toggle fees" must also be ON
    if (checked === true) {
      form.setFieldsValue({
        paymentDetails: {
          ...form.getFieldsValue(['paymentDetails']).paymentDetails,
          shouldShowFeesOption: true
        }
      });
    }
  };

  return (
    <>
      <Row>
        <Col
          {...headerLayout}
          style={{ fontSize: '17px', fontWeight: 'bold', display: 'inline-block', marginBottom: '10px' }}
        >
          Display Fees Options
        </Col>
      </Row>

        <Form.Item
          {...checkboxesLayout}
          name={['paymentDetails', 'shouldAddOnFees']}
          valuePropName="checked"
          style={{ marginBottom: '8px' }}
        >
          <Checkbox disabled={disabled} onChange={handleShouldAddOnFeesChange}>
            Ask customer to accept fees by default
          </Checkbox>
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => 
            prevValues.paymentDetails?.shouldAddOnFees !== currentValues.paymentDetails?.shouldAddOnFees
          }
        >
          {({ getFieldValue }) => {
            const shouldAddOnFees = getFieldValue(['paymentDetails', 'shouldAddOnFees']);
            const isToggleDisabled = disabled || shouldAddOnFees === true;
            return (
              <Form.Item
                {...checkboxesLayout}
                name={['paymentDetails', 'shouldShowFeesOption']}
                valuePropName="checked"
                style={{ marginBottom: '8px' }}
              >
                <Checkbox disabled={isToggleDisabled}>
                  Allow customer to toggle fee option
                </Checkbox>
              </Form.Item>
            );
          }}
        </Form.Item>
    </>
  );
}


const EditTeamPaymentDetailsForm = ({ onUpdated, team, teamId, ...rest }) => {
  const [form] = Form.useForm();
  
  const onFinish = (values) => {
    const { paymentDetails } = team || {};
    const capturedValues = { ...values };
    if (capturedValues.paymentDetails) {
      capturedValues.paymentDetails = { ...paymentDetails, ...capturedValues.paymentDetails };
      capturedValues.paymentDetails.shouldAddOnFees = values.paymentDetails.shouldAddOnFees || false;
      capturedValues.paymentDetails.shouldShowFeesOption = values.paymentDetails.shouldShowFeesOption || false;
      
      // Enforce rule: If "Ask customer to accept fees" is ON, then "Allow customer to toggle fees" must also be ON
      if (capturedValues.paymentDetails.shouldAddOnFees === true) {
        capturedValues.paymentDetails.shouldShowFeesOption = true;
      }
      
      // Ensure fieldSettings is always an array (empty array if no fields are selected)
      if (!capturedValues.paymentDetails.fieldSettings || !Array.isArray(capturedValues.paymentDetails.fieldSettings)) {
        capturedValues.paymentDetails.fieldSettings = [];
      }
    }

    if (onUpdated) {
      onUpdated(capturedValues);
    }
  };

  //set initial permission values for team creation scenario
  if (!team.paymentDetails) {
    team.paymentDetails = { 
      shouldAddOnFees: true,
      shouldShowFeesOption: true,
    };
  } else {
    // Enforce rule: If "Ask customer to accept fees" is ON, then "Allow customer to toggle fees" must also be ON
    if (team.paymentDetails.shouldAddOnFees === true && team.paymentDetails.shouldShowFeesOption !== true) {
      team.paymentDetails.shouldShowFeesOption = true;
    }
  }

  return (
    <Form
      {...FormItemLayout}
      form={form}
      name="teamPaymentDetailsForm"
      onFinish={onFinish}
      initialValues={{...team }}
      scrollToFirstError
    >
      <Input.Group style={{ textAlign: 'left' }}>
        <TeamEditPaymentDetailsFeesFormItem
          team={team}
          form={form}
        />
        <div style={{ textAlign: 'center' }}>
          <EditFieldSettingsView form={form}/>
        </div>
      </Input.Group>
      <Form.Item
        {...tailFormItemLayout}
      >
      <Button
          type="primary"
          htmlType="submit"
          style={{ width: 'auto', maxWidth: '325px' }}
        >
        {"Save Changes"}
      </Button>
      </Form.Item>
    </Form>
  );
}

export const TeamPaymentDetailsSettingsUpdate = ({ teamId, team, onLoading }) => {
    const teamDetailsModel = new StrikeTeamDetailsModel({
        teamId,
    });
    const [loading, setLoading] = useState(false);

    const handleUpdate = async (team) => {
        onLoading && onLoading({ message: `Saving payment details...` });
        setLoading(true);
        await teamDetailsModel.updatePaymentDetails(team);
        setLoading(false);
        onLoading && onLoading({ message: null })
    }

    return (
        <EditTeamPaymentDetailsForm
          team={team}
          onUpdated={handleUpdate}
          teamId={teamId}
        />
    )
}
